import Container from "components/grid/container";

import styles from "./styles.module.css";

const NotFoundHighlighter = () => {
  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.mediaWrap}>
          <source srcSet="/assets/images/not-found.webp" type="image/webp" />
          <source srcSet="/assets/images/not-found.png" type="image/png" />
          <img src="/assets/images/not-found.png" />
        </div>
        <h1 className={styles.title}>Üzgünüz, aradığınız sayfayı bulamadık.</h1>
        <div className={styles.contentWrap}>
          <p>
            <b>info@emlakjet.com</b> adresine e-posta gönderebilir ya da{" "}
            <a className={styles.redirectLink} href="/iletisim">
              iletişim sayfamızdan
            </a>{" "}
            bize mesaj bırakabilirsiniz.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default NotFoundHighlighter;
